import React, { Component } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import { connect } from "react-redux";
import classNames from "classnames";
import { DateRange as DateRangeIcon } from "@mui/icons-material";
import { ValidatorForm } from "react-material-ui-form-validator";
import DatePickerValidatorElement from "../../../../components/validation/DatePickerValidatorElement";
import moment from "moment/moment";

class TerminationEmployeeDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      terminationDate: null,
      errorMessage: "",
      openConfirmDialog: false,
      openAlertDialog: false,    // add this
      alertMessage: ""  
    };
  }

  // Define error codes list inside the class
  TERMINATION_ERROR_CODES = [
    "MM_ERR_103", "MM_ERR_104"
  ];

  componentWillMount() {
    const FORMAT_DATE = "DD/MM/YYYY";

    ValidatorForm.addValidationRule(`terminationDateValid`, value => {
      // termination date validation revoked
      let coverageStartDate = moment(this.props.selectedRecord.coverage_start_date, FORMAT_DATE);
      let dateHrSendInstruction = moment(moment(), FORMAT_DATE);
      let lastDateOfEmployment = moment(value, FORMAT_DATE);
      let diffInDays = moment.duration(dateHrSendInstruction.diff(lastDateOfEmployment)).asDays();
      if (lastDateOfEmployment.isSameOrAfter(coverageStartDate)) {
        if (diffInDays <= 31) {
          return true;
        } else {
          if (lastDateOfEmployment.isSameOrAfter(dateHrSendInstruction, "day")) {
            return true;
          } else {
            this.setState({
              errorMessage:
                "Late notification of last date of employment. Thus, last date of employment should be on " +
                dateHrSendInstruction.format(FORMAT_DATE) +
                " or later"
            });
            return false;
          }
        }
      } else {
        this.setState({ errorMessage: "Last date of employment cannot be earlier than coverage start date" });
        return false;
      }
    });
  }

  setTerminationDate = date => {
    this.setState({ terminationDate: date });
  };

  handleCompletedSubmit = () => {
    this.setState({ openConfirmDialog: true });
    //this.props.confirmHandler(moment(this.state.terminationDate).format("DD/MM/YYYY"));
  };

  handleConfirm = () => {
    this.setState({ openConfirmDialog: false });
    this.props.confirmHandler(moment(this.state.terminationDate).format("DD/MM/YYYY"))
      .catch(error => {
        const errorCode = error?.data?.error;
        // Get error message from server response
        const serverMessage = error?.data?.message;
        if (this.TERMINATION_ERROR_CODES.includes(errorCode)) {
          this.setState({
            openAlertDialog: true,
            alertMessage: serverMessage  // use server error message directly
          });
        }
      });
  };

  handleCloseAlertDialog = () => {
    this.setState({ openAlertDialog: false, alertMessage: "" });
    // Also close the main termination dialog
    this.props.closeHandler();
  };

  handleCancelConfirm = () => {
    this.setState({ openConfirmDialog: false });
  };

  handleButtonSubmit = () => {
    this.refs.form.submit();
  };

  render() {
    const { name, selectedRecord, open, closeHandler, icon, classes } = this.props;
    const { openConfirmDialog, terminationDate, openAlertDialog, alertMessage } = this.state;
    
    return (
      <>
      <Dialog
        open={open}
        onClose={closeHandler}
        aria-labelledby={`${name}-title`}
        aria-describedby={`${name}-description`}
      >
        <div className={classes.dialogTitleIcon}>{icon}</div>
        <DialogContent className={classes.dialogContent}>
          <ValidatorForm ref="form" onSubmit={this.handleCompletedSubmit}>
            <div>
              <DialogTitle>Remove Employee From Policy?</DialogTitle>
              <Typography variant="subheading" className={classes.padding}>
                Employee selected:
                <span className={classes.textHighlight}>{selectedRecord ? `${selectedRecord.full_name}` : ""}</span>
              </Typography>
            </div>
            <div className={classes.padding}>
              <DatePickerValidatorElement
                // style={{ width: "100%" }}
                fullWidth
                label={!this.state.terminationDate && "Please enter last date of employment"}
                name={"coverage_end_date"}
                autoComplete="[off]"
                clearable
                value={this.state.terminationDate}
                onChange={this.setTerminationDate}
                format="DD/MM/YYYY"
                animateYearScrolling={true}
                InputProps={{
                  endAdornment: <DateRangeIcon />
                }}
                validators={["required", `terminationDateValid`]}
                errorMessages={["", this.state.errorMessage]}
              />
            </div>
            <div className={classes.dialogNote}>
              <Typography variant="caption">
                <strong>Please note: </strong> The Employee and dependant(s) will be covered till last day of
                employment.
              </Typography>
            </div>
          </ValidatorForm>
        </DialogContent>
        <DialogActions className={classNames(classes.dialogAction, classes.centerContent)}>
          <Button onClick={closeHandler} className={classes.button} color="primary" autoFocus>
            Cancel
          </Button>
          <Button
            onClick={this.handleButtonSubmit}
            className={classes.button}
            color="primary"
            variant="raised"
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog */}
        <Dialog open={openConfirmDialog} onClose={this.handleCancelConfirm}>
          <DialogContent>
            <Typography variant="h6" style={{ color: "red", fontWeight: "bold", marginBottom: 12 }}>
              Confirmation
            </Typography>
            <Typography variant="body1">
              The last date of employment and coverage for employee{" "}
              {selectedRecord ? selectedRecord.full_name : ""} and his/her dependant(s) (if
              applicable), is on{" "}
              {terminationDate ? moment(terminationDate).format("DD/MM/YYYY") : ""}.
            </Typography>
          </DialogContent>
          <DialogActions className={classNames(classes.dialogAction, classes.centerContent)}>
            <Button onClick={this.handleCancelConfirm} className={classes.button} color="primary">
              Cancel
            </Button>
            <Button
              onClick={this.handleConfirm}
              className={classes.button}
              color="primary"
              variant="raised"
              autoFocus
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

        {/* Alert Message Dialog */}
        <Dialog open={openAlertDialog} onClose={this.handleCloseAlertDialog}>
          <DialogContent className={classes.dialogContent}>
            <Typography
              variant="h6"
              style={{ color: "red", fontWeight: "bold", marginBottom: 12 }}
            >
              Alert Message
            </Typography>
            <Typography variant="body1">
              {alertMessage}
            </Typography>
          </DialogContent>
          <DialogActions className={classNames(classes.dialogAction, classes.centerContent)}>
            <Button
              onClick={this.handleCloseAlertDialog}
              className={classes.button}
              color="primary"
              variant="raised"
              autoFocus
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

const styles = theme => ({
  dialogContent: {
    maxWidth: 420
  },
  centerContent: {
    display: "flex",
    justifyContent: "center"
  },
  button: {
    width: 130
  },
  dialogTitleIcon: {
    display: "flex",
    justifyContent: "center",
    marginTop: 20
  },
  padding: {
    padding: "0px 20px"
  },
  dialogAction: {
    marginBottom: 20
  },
  dialogNote: {
    padding: 20
  },
  textHighlight: {
    color: "red"
  }
});

function mapStateToProps(state, prop) {
  return { policy: state.HR.coverage.policy };
}

export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(TerminationEmployeeDialog));
